import CategoryIcon from '@mui/icons-material/Category';
import HomeIcon from '@mui/icons-material/Home';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import ScienceIcon from '@mui/icons-material/Science';
import {
    Box,
    Divider,
    Drawer,
    IconButton,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Skeleton,
    Stack,
    styled,
    Tooltip,
    Typography,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { SubscribersAdmin } from '../../../hooks/useSubscribers';
import { UserContextType } from '../../../store/UserContext';
import HeaderSideMenuSubscriber from '../../HeaderSideMenuSubscriber';
import AdminStatsBlock from './AdminStatsBlock';

export const DRAWER_WIDTH = 280;

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
}));

const SideMenuDrawer = (props: {
    userContext: UserContextType;
    subscribers: any[] | SubscribersAdmin | undefined;
    subscribersLoading: boolean;
    open: any;
    drawerState: boolean;
    handleDrawerToggle: (event: React.KeyboardEvent | React.MouseEvent) => void;
    handleToggleSubscriberMenu: (username: string) => void;
}) => {
    const { userContext, subscribers, subscribersLoading, open, drawerState, handleDrawerToggle, handleToggleSubscriberMenu } = props;

    return (
        <Drawer
            anchor="left"
            open={drawerState}
            onClose={handleDrawerToggle}
            sx={{
                width: DRAWER_WIDTH,
                flexShrink: 0,
                [`& .MuiDrawer-paper`]: { width: DRAWER_WIDTH, boxSizing: 'border-box' },
            }}
        >
            <DrawerHeader>
                <div style={{ width: '100%' }}>
                    <Stack direction="row" spacing={1} alignItems="center" justifyContent={'space-between'}>
                        <Typography variant="h6" align="left">
                            OnlyStruggles
                        </Typography>
                        {userContext.isAdmin && (
                            <Stack direction="row" spacing={0} alignItems="center">
                                <IconButton
                                    color="primary"
                                    component={Link}
                                    to={`/admin/onlyfans/api/request`}
                                    onClick={handleDrawerToggle}
                                    onKeyDown={handleDrawerToggle}
                                >
                                    <Tooltip title="API Tester" placement="top" arrow>
                                        <ScienceIcon />
                                    </Tooltip>
                                </IconButton>
                                <IconButton
                                    color="primary"
                                    component={Link}
                                    to={`/admin/onlypromote/categories`}
                                    onClick={handleDrawerToggle}
                                    onKeyDown={handleDrawerToggle}
                                >
                                    <Tooltip title="onlypromote.me Categories" placement="top" arrow>
                                        <CategoryIcon />
                                    </Tooltip>
                                </IconButton>
                                <IconButton
                                    color="primary"
                                    component={Link}
                                    to={`/subscribers`}
                                    onClick={handleDrawerToggle}
                                    onKeyDown={handleDrawerToggle}
                                >
                                    <Tooltip title="All Subscribers" placement="top" arrow>
                                        <PeopleAltIcon />
                                    </Tooltip>
                                </IconButton>
                            </Stack>
                        )}
                    </Stack>
                </div>
            </DrawerHeader>

            <Divider />

            {userContext.isAdmin && (
                <>
                    <AdminStatsBlock />
                    <Divider />
                </>
            )}

            <Box role="presentation" paddingTop={0}>
                <List dense={true} disablePadding>
                    <ListItemButton component={Link} to={'/'} onClick={handleDrawerToggle} onKeyDown={handleDrawerToggle}>
                        <ListItemIcon
                            sx={{
                                minWidth: '32px',
                            }}
                        >
                            <HomeIcon />
                        </ListItemIcon>
                        <ListItemText primary="Home" />
                    </ListItemButton>

                    <Divider />

                    {subscribersLoading ? (
                        <Skeleton />
                    ) : (
                        <>
                            {(!subscribers || (Array.isArray(subscribers) && subscribers.length === 0)) && (
                                <Typography variant="body1" sx={{ marginLeft: 2, marginTop: 2 }}>
                                    No Accounts Found
                                </Typography>
                            )}
                            {subscribers &&
                                Array.isArray(subscribers) &&
                                subscribers.map(subscriber => (
                                    <HeaderSideMenuSubscriber
                                        subscriber={subscriber}
                                        key={`menu_${subscriber.username}`}
                                        open={open}
                                        handleDrawerToggle={handleDrawerToggle}
                                        handleToggleSubscriberMenu={handleToggleSubscriberMenu}
                                    />
                                ))}
                        </>
                    )}
                </List>
            </Box>
        </Drawer>
    );
};

export default SideMenuDrawer;
